<template>
  <div v-show="!layout.isTablet" class="box">
    <div>
      <b-button variant="link" @click="logout" :class="'logout-btn'">Cerrar Sesión</b-button>
    </div>
    <div class="links">
      <a :href="`${URLS.ROOT_SITE}informacion-legal/condiciones-generales`" target="_blank">Terminos</a>
      <a :href="`${URLS.ROOT_SITE}informacion-legal/resumen-de-la-nueva-política-de-privacidad`" target="_blank">Privacidad</a>
      <a href="mailto:info@farmapremium.es">Ayuda</a>
    </div>
  </div>
</template>

<script setup>
import { Auth, URLS } from '@/dashboards'
import { piniaStoreModules } from 'frontendcommon-3'
import { getActivePinia } from 'pinia'
import { computed } from 'vue'

const pinia = getActivePinia()
const commonStore = piniaStoreModules.useCommon(pinia)
const layout = computed(() => commonStore.layout)
const auth = new Auth()

function logout () {
  auth.redirectLogout(URLS.ROOT_SITE)
}
</script>

<style scoped lang="scss">
.box {
  width: 80%;
  .logout-btn{
    padding-left: 0;
  }
  .links{
    display: flex;
    gap: 10px;
    a{
      color: #000;
    }
  }
}
</style>
